import React from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaTiktok,
  FaTwitter,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";
import Logo from "../Assest/images/Rayaness.png";
import { useNavigate } from "react-router-dom";
 // Assuming this is the correct path to your logo

const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-b from-gray-900 to-black pt-16 sm:pt-20 pb-10 overflow-hidden">
      {/* Enhanced Decorative Gradient */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] sm:w-[600px] h-[400px] sm:h-[600px] rounded-full bg-[#f36812]/10 blur-[100px] sm:blur-[150px] -z-0"
        style={{
          background:
            "radial-gradient(circle, rgba(243,104,18,0.2) 0%, rgba(0,0,0,0) 70%)",
        }}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 sm:gap-12 mb-12 sm:mb-16">
          {/* Brand Section */}
          <div className="lg:col-span-4">
            <div className="flex items-center mb-6">
              <img
                src={Logo}
                alt="Rayane Logo"
                className="w-12 h-12 sm:w-16 sm:h-16 mr-3 object-contain filter drop-shadow-[0_0_8px_rgba(243,104,18,0.3)]"
              />
              <h2 className="text-white text-2xl sm:text-3xl font-light tracking-widest">
                RAYANE
              </h2>
            </div>
            <p className="text-gray-300 text-xs sm:text-sm leading-relaxed mb-6 sm:mb-8 max-w-xs">
              Redefining luxury with exquisite gold and diamond craftsmanship.
              Every creation is a masterpiece.
            </p>
            <div className="flex space-x-4 sm:space-x-5">
              {[
                { Icon: FaInstagram, link: "https://instagram.com" },
                { Icon: FaFacebookF, link: "https://facebook.com" },
                { Icon: FaYoutube, link: "https://youtube.com" },
                { Icon: FaTiktok, link: "https://tiktok.com" },
                { Icon: FaTwitter, link: "https://twitter.com" },
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border border-gray-700 flex items-center justify-center text-gray-300 hover:border-[#f36812] hover:bg-[#f36812] hover:text-white transition-all duration-300 hover:shadow-[0_0_10px_rgba(243,104,18,0.5)]"
                >
                  <social.Icon size={16} className="sm:text-lg" />
                </a>
              ))}
            </div>
            <div className="div flex items-center mt-6 cursor-pointer" onClick={() => window.open("https://raetrading.nl/", "_blank")}>
              <img src={"/Assets/images/footer logo.png"} alt="" className="w-12 h-12 sm:w-16 sm:h-16 mr-3 object-contain filter drop-shadow-[0_0_8px_rgba(243,104,18,0.3)]" />
              <h1 className="text-white text-1xl sm:text-2xl font-light tracking-widest">RAE TRADINFG B.V</h1>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h3 className="text-white text-xs sm:text-sm font-medium tracking-widest mb-4 sm:mb-6 uppercase border-b border-[#f36812]/20 pb-2">
              About Rayane
            </h3>
            <ul className="space-y-3 sm:space-y-4">
              {[
                "About Us",
                "Core Values",
                "Careers",
                "Press Releases",
                "Blog",
                "Sitemap",
              ].map((item, index) => (
                <li key={index}>
                  <a
                    href="#"
                    className="text-gray-300 text-xs sm:text-sm hover:text-[#f36812] transition-all duration-300 hover:translate-x-1"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Company */}
          {/* <div className="lg:col-span-2">
            <h3 className="text-white text-xs sm:text-sm font-medium tracking-widest mb-4 sm:mb-6 uppercase border-b border-[#f36812]/20 pb-2">
              Our Company
            </h3>
            <ul className="space-y-3 sm:space-y-4">
              {[
                "Shopping App",
                "Media Enquiries",
                "Web Development",
                "Other Services",
              ].map((item, index) => (
                <li key={index}>
                  <a
                    href="#"
                    className="text-gray-300 text-xs sm:text-sm hover:text-[#f36812] transition-all duration-300 hover:translate-x-1"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Contact Information */}
          <div className="lg:col-span-4">
            <h3 className="text-white text-xs sm:text-sm font-medium tracking-widest mb-4 sm:mb-6 uppercase border-b border-[#f36812]/20 pb-2">
              Get in Touch
            </h3>
            <ul className="space-y-4 sm:space-y-5">
              <li className="flex items-start space-x-3">
                <FaMapMarkerAlt className="text-[#f36812] mt-1 text-sm sm:text-base" />
                <span className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  502 New Design Str, Melbourne, Australia
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <FaPhone className="text-[#f36812] text-sm sm:text-base" />
                <span className="text-gray-300 text-xs sm:text-sm">
                  +937665464
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <FaEnvelope className="text-[#f36812] text-sm sm:text-base" />
                <a
                  href="mailto:info@raetrading.nl"
                  className="text-gray-300 text-xs sm:text-sm hover:text-[#f36812] transition-duration-300"
                >
                  info@raetrading.nl
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Enhanced Divider */}
        <div className="h-[1px] bg-gradient-to-r from-transparent via-[#f36812]/30 to-transparent mb-8" />

        {/* Copyright */}
        <div className="text-center">
          <p className="text-gray-400 text-xs sm:text-sm">
            © {new Date().getFullYear()} Rayane. All rights reserved.
          </p>
        </div>
      </div>

      {/* Subtle Bottom Gradient */}
      <div className="absolute bottom-0 left-0 w-full h-20 bg-gradient-to-t from-black to-transparent -z-0" />
    </footer>
  );
};

export default Footer;
